import { CookieStorageKeysInterface } from './types';

export enum CookieStorageKeyEnums {
  EMAIL,
  AUTH_TOKEN,
  TOKEN_TYPE,
}

export const CookieStorageKeys: CookieStorageKeysInterface = {
  EMAIL: 'EMAIL',
  AUTH_TOKEN: 'AUTH_TOKEN',
  TOKEN_TYPE: 'TOKEN_TYPE',
};
